const Style = {
    lede: 'mb-10 mt-3 max-w-[620px] text-base text-text-secondary md:text-lg',

    /* Two cards, so the row is sized to them rather than stretched across five
       equal grid tracks. `groups` / `groupLabel` and the muted card variant went
       with the roadmap row (see integrations.js). */
    grid: 'flex flex-wrap gap-3',

    card: `flex min-w-[10rem] items-center gap-3 rounded-xl border border-border bg-surface p-4
    transition-[box-shadow,border-color] duration-150 ease-out hover:border-primary-400 hover:shadow-md`,

    /* Bare, on no tile of its own. The mark used to sit in a
       `bg-primary-50 border-primary-200` well, which made sense around a
       primary-tinted monogram and fights real brand artwork: Slack's four
       colours and ClickUp's gradient bring their own. Both source crops are
       square with transparent padding, so one square box fits both. */
    logo: 'h-7 w-7 flex-none object-contain',

    name: 'truncate text-sm font-medium text-text-primary',
    more: 'mb-0 mt-8 text-sm text-text-muted',
};

export default Style;
